import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import CheckboxInput        from '../Fields/CheckboxInput';

let Quote = require('../Managers/Quote');
let DomainInfo = require('../Managers/DomainInfo');

class MarketingPermissions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            permissionsIndex : {},
            flags: {},
        };
    }

    componentWillMount() {
        let permissionsIndex = DomainInfo.getMarketingPermissions();

        let flags = {};
        Object.keys(permissionsIndex).map(key => {
            flags[key] = false;
        });
        this.setState({
            permissionsIndex,
            flags,
        });
    }

    /**
     * given a single permissions index key, toggle the flag
     * for that permission in both state and local storage
     */
    toggleMarketingPermission(key) {
        // for each of the required permissions, toggle them
        let flags = this.state.flags;
        flags[key] = !flags[key];
        this.setState({
            flags
        }, () => {
            // for each required permision, set it into local storage with the current flag
            Quote.setByPath('BaseIndividualApplication.' + key, flags[key]);
        });
    }

    render() {
        return(
            <question-row class="header-row">
                {!window.uornorb(Quote.getByPath('domainInfo.canContactApplicantByPhoneAndPost')) ?
                    <div>
                        <h3>Keeping you informed</h3>
                        <p>
                            We will update you throughout the referencing process to keep you informed on progress.
                            We'd also love to tell you about our range of products and services for tenants, but if you'd prefer not to hear from us
                            then please <a href="#" onClick={() => { this.props.showPhonePostModal(); }}><strong>just let us know</strong></a>.
                        </p>
                    </div>
                : <br /> }

                {Object.keys(this.state.permissionsIndex).map(key => {
                    return (
                        <div key={key} className="question-main">
                            <div className="question-input">
                                <div className="row-2 uneven">
                                    <div className="column fixed">
                                        <div className="card trigger" onClick={() => { this.toggleMarketingPermission(key); }}>
                                            {this.state.permissionsIndex[key].image ?
                                                <img src={this.state.permissionsIndex[key].image} className="marketing-selection-icon" />
                                            : null}
                                            <div data-field="email2">
                                                <CheckboxInput
                                                    question="I agree"
                                                    fieldName={"checkbox_" + key}
                                                    source="BaseIndividualApplication"
                                                    overriddenFlag={this.state.flags[key]}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="column" dangerouslySetInnerHTML={{__html: this.state.permissionsIndex[key].text}} />
                                </div>
                            </div>
                            <br />
                        </div>
                    );
                })}
            </question-row>
        );
    }
}

MarketingPermissions.propTypes = {
    showPhonePostModal:   PropTypes.func,
};

export default MarketingPermissions;


// WEBPACK FOOTER //
// ./src/components/Fragments/MarketingPermissions.js